export class _TrueTypeTableInfo {
    get _empty() {
        const empty = (this._offset === this._length && this._length === this._checksum && this._checksum === 0);
        return empty;
    }
}
export class _TrueTypeOS2Table {
}
export class _TrueTypePostTable {
}
export class _TrueTypeNameTable {
}
export class _TrueTypeMicrosoftCmapSubTable {
}
export class _TrueTypeHorizontalHeaderTable {
}
export class _TrueTypeHeadTable {
}
export class _TrueTypeCmapTable {
}
export class _TrueTypeCmapSubTable {
}
export class _TrueTypeAppleCmapSubTable {
}
export class _TrueTypeTrimmedCmapSubTable {
}
